import React from "react";
import PropTypes from "prop-types";

export default function Tag({ label }) {
  if (!label) {
    return null;
  }
  return <div className="tag">{label}</div>;
}

Tag.propTypes = {
  label: PropTypes.string,
};
